import {Menu, Transition} from "@headlessui/react";
import classNames from "classnames";
import React, {Fragment, useState} from "react";
import styles from "./AziendaNavigator.module.css"
import Toggle from "../../components/Toggle";
import {AziendaNavRecord} from "@commons/mapping/AziendaNavRecord";
import {IconChevronDown, IconChevronLeft, IconChevronRight, IconChevronsLeft, IconChevronsRight} from "@tabler/icons-react";

interface AziendaNavigatorProps {
    aziendaNavData?: AziendaNavRecord;
    isLoading: boolean;
    setLink: (newLink: string | null) => void;
}

const AziendaNavigator: React.FC<AziendaNavigatorProps> = ({aziendaNavData, isLoading, setLink}) => {
    const [soloAziende, setSoloAziende] = useState<boolean>(false);

    const links = {
        first: aziendaNavData ? aziendaNavData.first : null,
        previous: aziendaNavData ? aziendaNavData.previous : null,
        next: aziendaNavData ? aziendaNavData.next : null,
        last: aziendaNavData ? aziendaNavData.last : null
    }

    const asMenu = true;
    const items = [
        {name: 'Ordina per ID', href: '#'},
        {name: 'Ordina per codice', href: '#'},
        {name: 'Ordina per denominazione', href: '#'},
    ];

    return (<>
        <div className="inline-flex rounded-md shadow mb-1">
            <div className={`rounded-l-md ${styles.navBtn}`}>
                <Toggle initialState={soloAziende} onChange={setSoloAziende}
                        label="Solo aziende" labelPosition="right"/>
            </div>
            <button type="button" className={`-ml-px ${styles.navBtn}`}
                    disabled={links.first === null || isLoading}
                    onClick={() => setLink(links.first)}>
                <IconChevronsLeft className="h-6" strokeWidth={1.5}/>
            </button>
            <button type="button" className={`-ml-px ${styles.navBtn}`}
                    disabled={links.previous === null || isLoading}
                    onClick={() => setLink(links.previous)}>
                <IconChevronLeft className="h-6" strokeWidth={1.5}/>
            </button>
            <button type="button" className={`-ml-px ${styles.navBtn}`}
                    disabled={links.next === null || isLoading}
                    onClick={() => setLink(links.next)}>
                <IconChevronRight className="h-6" strokeWidth={1.5}/>
            </button>
            <button type="button" className={`-ml-px ${styles.navBtn}`}
                    disabled={links.last === null || isLoading}
                    onClick={() => setLink(links.last)}>
                <IconChevronsRight className="h-6" strokeWidth={1.5}/>
            </button>

            {/*        {!asMenu && <>
                <label htmlFor="message-type" className="sr-only">
                    Select message type
                </label>
                <select
                    id="message-type"
                    name="message-type"
                    className="relative -ml-px block w-full rounded-l-none rounded-r-md border border-gray-300 bg-white py-2 pl-3 pr-9 text-sm font-medium hover:bg-gray-50 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                    {items.map((item) => (<option key={item.name}>{item.name}</option>))}
                </select>
            </>}*/}

            {asMenu && <Menu as="div" className="relative inline-block -ml-px">
                <Menu.Button
                    className="h-full px-2 max-sm:px-1 py-2 relative inline-flex items-center rounded-r-md border border-gray-300
                    bg-white text-sm font-medium
                    hover:bg-gray-50
                    focus:z-10 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500">
                    Cambia ordinamento
                    <IconChevronDown className="h-6" strokeWidth={1.5}/>
                </Menu.Button>

                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100">

                    <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5
                    focus:outline-none">
                        <div className="py-1">
                            {items.map((item) => (
                                <Menu.Item key={item.name}>
                                    {({active}) => (
                                        <a
                                            href={item.href}
                                            className={classNames(
                                                active ? 'bg-gray-100' : '',
                                                'block px-4 py-2 text-sm'
                                            )}>
                                            {item.name}
                                        </a>
                                    )}
                                </Menu.Item>
                            ))}
                        </div>
                    </Menu.Items>

                </Transition>

            </Menu>}
        </div>
    </>)
}
export default AziendaNavigator;
